"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearMessages = exports.removeMessage = exports.displayMessage = exports.CLEAR_ALL_STATES = exports.REMOVE_MESSAGE = exports.DISPLAY_MESSAGE = void 0;
/* ++++++++++ --------------- EXPORTS - MESSAGES - ACTIONS --------------- ++++++++++ */

var DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
exports.DISPLAY_MESSAGE = DISPLAY_MESSAGE;
var REMOVE_MESSAGE = 'REMOVE_MESSAGE';
exports.REMOVE_MESSAGE = REMOVE_MESSAGE;
var CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';
exports.CLEAR_ALL_STATES = CLEAR_ALL_STATES;

var displayMessage = function displayMessage(message) {
  return {
    type: DISPLAY_MESSAGE,
    message: message
  };
};

exports.displayMessage = displayMessage;

var removeMessage = function removeMessage(filterProp, filterVal, messageType, alignment) {
  return {
    type: REMOVE_MESSAGE,
    filterProp: filterProp,
    filterVal: filterVal,
    messageType: messageType,
    alignment: alignment
  };
};

exports.removeMessage = removeMessage;

var clearMessages = function clearMessages() {
  return {
    type: CLEAR_ALL_STATES
  };
};

exports.clearMessages = clearMessages;